<template>
  <div class="page page--speed">
    <Head>
      <title>{{ $t("speed-title") }} {{ $t("speed-subtitle") }}</title>
      <body class="site--speed" />
      <meta name="description" :content="$t('speed-description')" />
      <meta name="og:title" :content="$t('speed-title')" />
      <meta name="og:description" :content="$t('speed-description')" />
    </Head>
    <AdUnit unit="1" />
    <h1>
      <router-link :to="pathForLocale({ path: '/how-fast-am-i-going' })">{{
        $t("speed-title")
      }}</router-link>
    </h1>
    <SpeedReadings
      :locations="locations"
      :status="status"
      :speedUnits="speedUnits"
    />
    <SpeedSettings v-model="speedUnits" v-if="status !== 'error'" />
    <AdUnit unit="2" />
    <!-- <SpeedChart
      v-if="status !== 'error'"
      :locations="locations"
      @clearLocations="locations = []"
    /> -->
    <TheFooter
      :fast="false"
      :elevation="true"
      :title="$t('speed-about.heading')"
    >
      <div class="section section--about">
        <div class="text-block" v-html="$t('speed-about.html')"></div>
        <AdUnit unit="3" />
      </div>
      <template v-slot:nav>
        <li>
          <router-link :to="pathForLocale({ path: '/how-fast-am-i-going' })">{{
            $t("speed-title")
          }}</router-link>
        </li>
        <li>
          <router-link :to="pathForLocale({ path: '/speed-calculator' })">{{
            $t("speed-calculator-title")
          }}</router-link>
        </li>
        <li>
          <router-link :to="pathForLocale({ path: '/speed-converter' })">{{
            $t("speed-converter-title")
          }}</router-link>
        </li>
      </template>
    </TheFooter>
  </div>
</template>
<script>
import { Head } from "@vueuse/head";
import SpeedChart from "@/components/SpeedChart.vue";
import { pathForLocale, isHeadless } from "@/helpers";
import SpeedReadings from "@/components/SpeedReadings.vue";
import SpeedSettings from "@/components/SpeedSettings.vue";
import TheFooter from "@/components/TheFooter.vue";
import AdUnit from "@/components/AdUnit.vue";

export default {
  components: {
    SpeedReadings,
    SpeedSettings,
    TheFooter,
    SpeedChart,
    AdUnit,
    Head
  },
  data() {
    return {
      hasFocus: true,
      locations: [],
      watchId: null,
      status: "loading",
      speedUnits: isHeadless()
        ? "mph"
        : localStorage.getItem("speedUnits") || "mph"
    };
  },
  methods: {
    pathForLocale,
    handleVisiblityChange() {
      this.hasFocus = !document.hidden;
      console.log("handleVisiblityChange", this.hasFocus);
      if (this.hasFocus) {
        this.watchUserLocation();
      } else {
        this.stopWatchingUserLocation();
      }
    },
    watchUserLocation() {
      if (this.watchId !== null) {
        this.stopWatchingUserLocation();
      }
      if (isHeadless() || typeof navigator.geolocation === "undefined") {
        this.locationError();
        return;
      }
      const watchId = navigator.geolocation.watchPosition(
        location => {
          if (this.watchId) {
            this.locations.push(location);
            this.status = "watching";
          }
        },
        this.locationError,
        {
          enableHighAccuracy: true,
          timeout: 30 * 1000
        }
      );
      this.watchId = watchId;
    },
    stopWatchingUserLocation() {
      if (isHeadless() || typeof navigator.geolocation === "undefined") {
        return;
      }
      navigator.geolocation.clearWatch(this.watchId);
      this.watchId = null;
      this.status = "not-watching";
    },
    locationError() {
      // disable settings a location error when prerendering
      if (isHeadless()) {
        return;
      }
      this.status = "error";
    }
  },
  mounted() {
    if (isHeadless()) {
      return;
    }
    this.watchUserLocation();
    window.addEventListener("visibilitychange", this.handleVisiblityChange);
  },
  unmounted() {
    window.removeEventListener("visibilitychange", this.handleVisiblityChange);
  }
};
</script>
